import styles from "../Styles/Footer.module.css";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className={styles.copyright}>
      &copy; Copyrights {currentYear} Xuber Services.
    </div>
  );
};
